import { isEmpty, isNull } from './utils';

const validateCaptcha = (token) => {
  if (isNull(token)) {
    return {
      type: 'manual',
      message: 'Session expired'
    };
  } else if (isEmpty(token)) {
    return {
      type: 'manual',
      message: 'Please verify whether you are a human'
    };
  } else {
    return null;
  }
};

export { validateCaptcha };
